import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import Header from './header/header.js';
import Title from './title/title.js';
import Paragraph from './paragraph/paragraph.js';
import Twitter from './twitter/twitter.js';


class App extends React.Component {
  render(){
    var title = "I create teams who create digital experiences. Both from scratch.";
    var paragraphs = [1,2];

    paragraphs[0] = "My name is Christian Renner. I work at XXXLutz Group, doing eCommerce, Hybris & Customer Engagement. leading http://xxxl.digital";
    paragraphs[1] = "You could follow me up on <a href='https://twitter.com/creesoo'>Twitter</a> or <a href='https://www.linkedin.com/in/christianrenner/'>Linkedin</a>.";

    var content = paragraphs.map((para) =>
      <Paragraph content={para} />
  );
    return(
      <div className="content">
      <Header />
      <Title title={title}/>
      {content}
      <Twitter />
      </div>
    );
  }

}


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js